import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

function Channel(props) {
  const { channel, channelId, subscribeToChannel } = props;
  const active = channel.id === channelId ? "active-chat" : "";

  return (
    <div className={"people-box " + active}>
      <Link
        to={`/messages/${channel.name}`}
        onClick={() => subscribeToChannel(channel.id)}
      >
        <div className='people-box-inner'>
          <div className='people-img'>
            {
              channel.images.map((image) => {
                return (<img key={image.id} src={image.url} alt={image.alt} className='rounded-circle' />);
              })
            }
          </div>
          <div className='people-info'>
            <h5>
              {channel.user_name}
              <span className='chat-date'>
                {channel.last_messaged_at}
              </span>
            </h5>
            {channel.job_title && (<p className='jobtitle'>{channel.job_title}</p>)}
            <p>{channel.last_message.content}</p>
          </div>
        </div>
      </Link>
    </div>
  );
}

Channel.propTypes = {
  channel: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    user_name: PropTypes.string.isRequired,
    images: PropTypes.arrayOf(PropTypes.object).isRequired,
    last_message: PropTypes.object.isRequired,
  }).isRequired,
  channelId: PropTypes.number,
  subscribeToChannel: PropTypes.func.isRequired
};

Channel.defaultProps = {
  channelId: null
};

export default Channel;
